// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__29VLN","rootSmall":"AddTileButton_rootSmall__2_QaI"};